/** Shared horizontal layout for landing page — capped width centered, aligned with the navbar */
export const LANDING_MAX_WIDTH = "max-w-full";

/** Side inset scales with viewport — stays modest on ultra-wide screens */
export const LANDING_PADDING_X =
  "px-4 sm:px-5 md:px-6 lg:px-8 xl:px-10 2xl:px-32";

export const LANDING_CONTAINER = `w-full ${LANDING_MAX_WIDTH} mx-auto`;

export const LANDING_CONTAINER_PADDED = `${LANDING_CONTAINER} ${LANDING_PADDING_X}`;

/** Footer and other full-width blocks — same inset as landing sections */
export const LANDING_PAGE_SHELL = LANDING_CONTAINER_PADDED;

/** Content inside the shell (no extra horizontal padding) */
export const LANDING_INNER = "w-full min-w-0";

/** Bleed horizontal carousels to the viewport edge inside a padded shell */
export const LANDING_CAROUSEL_BLEED_X =
  "-mx-4 sm:-mx-5 md:-mx-6 lg:mx-0";
